import React from 'react';
import './checks.scss';
import CheckObligation from '../../components/checkObligation';

import imageGroup from '../../assets/images/Group.png';


export default props => {

  let { itens, fieldConditional } = props;

  const getItens = (itens) => (
    <div>
      {
        itens.map((item, index) =>
          <div key={index}>
          <CheckObligation field={item.name} fieldConditional={fieldConditional}>
            {(validacoes) =>
              <div className="component-checks">
                <img className="" src={imageGroup} alt="checks" />
                <p>{item.value}</p>
              </div>}
          </CheckObligation>
          </div>
        )
      }
    </div>
  );

  return (
    <div>
      {getItens(itens)}
    </div>
  );
}
